<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">할인차량관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">무료차량 관리</p>
          <ul class="depth">
            <li><router-link to="/discountvehicle" title="할인차량 관리">할인차량 관리</router-link></li>
            <li><router-link to="/freevehicle" title="무료차량 관리">무료차량 관리</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">무료차량 등록</h3>
        <article>
          <!--table-->
          <div class="table horizontal-table">
            <table>
              <caption>
                무료차량 등록 테이블
              </caption>
              <colgroup>
                <col style="width: 15%; min-width: 60px" />
                <col style="width: auto" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">사용자명</th>
                  <td>
                    <input v-model="carOwnerNm" type="text" title="사용자명 입력" class="md" />
                  </td>
                </tr>
                <tr>
                  <th scope="row">차량번호</th>
                  <td>
                    <div class="flex">
                      <input
                        v-model="carNo"
                        @keyup.enter="duplicateCheck"
                        type="text"
                        title="차량번호 입력"
                        class="md"
                      />
                      <button type="button" @click="duplicateCheck" v-if="!sectnIdChkReturn" class="btn gray">중복확인</button>
                    </div>
                    <div class="error" v-if="!$v.carNo.required">필수 입력란입니다.</div>
                    <div class="error" v-if="!$v.carNo.carNoCheck">차량번호 형식에 맞지 않습니다.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">무료유형</th>
                  <td>
                    <select v-model="fctCode" name="" id="" class="md">
                      <option v-for="(item, index) in fctCodeList" :key="index" :value="item.code.code">
                        {{ item.code.codeNm }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">대상 주차장</th>
                  <td>
                    <select v-model="sectnId" name="" @change="sectnIdChk" id="" title="대상 주차장 선택" class="md">
                      <option v-for="(item, index) in parkingList" :key="index" :value="item.SECTN_ID">
                        {{ item.PARKING_NM }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <th scope="row">소속</th>
                  <td>
                    <div class="flex">
                      <input v-model="orgNm" type="text" class="md" />
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">적용요일</th>
                  <td>
                    <v-card flat>
                      <v-card-text>
                        <v-container fluid>
                          <v-row>
                            <v-checkbox v-model="applyDay" label="일" value="1"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="월" value="2"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="화" value="3"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="수" value="4"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="목" value="5"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="금" value="6"></v-checkbox>
                            <v-checkbox v-model="applyDay" label="토" value="7"></v-checkbox>
                          </v-row>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </td>
                </tr>
                <tr>
                  <th scope="row">무료기간</th>
                  <td>
                    <date-picker :propsDate="searchDate" @emitSetDate="emitSetDate"></date-picker>
                  </td>
                </tr>
                <tr>
                  <th scope="row">비고</th>
                  <td>
                    <input v-model="freeNote" type="text" title="비고 입력" />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <!--//table-->
        </article>
        <article class="btnArea">
          <!-- <button type="button" class="btn border" @click="$router.push('freevehicle')">목록</button> -->
          <button type="button" class="btn gray" @click="$router.push('freevehicle')">취소</button>
          <button type="button" class="btn blue" @click="save">저장</button>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import DatePicker from '../../../components/DatePicker2.vue';
import moment from 'moment';
import { required, helpers, or } from 'vuelidate/lib/validators';
const carNoRegex = helpers.regex('carNoRegex', /^\s*([가-히]{2}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegex2 = helpers.regex('carNoRegex', /^\s*([가-히]{3}){0,1}\s*[0-9]{2,3}[\s]*[가-히]{1}[\s]*[0-9]{4}\s*$/gi);
const carNoRegexDipl = helpers.regex(
  'carNoRegexDipl',
  /^\s*([외교,영사,준외,협정,국기,준영,대표]{2}){0,1}\s*[0-9]{3}[\s]*[-]{1}[\s]*[0-9]{3}\s*$/gi,
);

export default {
  data() {
    return {
      parkingList: [],
      searchDate: {
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        endDate: moment(new Date()).format('YYYY-MM-DD'),
      },
      carOwnerNm: '',
      carNo: '',
      freeNote: '',
      sectnId: '',
      applyDay: [],
      fctCodeList: [],
      fctCode: '',
      orgNm: '',
      sectnIdChkReturn: false,
    };
  },

  components: {
    DatePicker,
  },

  validations: {
    carOwnerNm: {
      required,
    },
    carNo: {
      required,
      carNoCheck: or(carNoRegex, carNoRegexDipl, carNoRegex2),
    },
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      const urls = ['/api/parking/map.json', '/api/admin/freecar/fctCode.json'];
      const req = urls.map(url => axios('get', url));
      const res = await Promise.all(req);
      const [parkingList, fctCodeList] = await Promise.all(res);
      this.parkingList = parkingList.data.parkingMapList;
      this.fctCodeList = fctCodeList.data.fctCodeList.result;
      this.parkingList.unshift({ PARKING_NM: '부설 주차장(가산금 없는 주차장)', SECTN_ID: -2 });
      this.parkingList.unshift({ PARKING_NM: '전체', SECTN_ID: -1 });
    },

    emitSetDate(startDate, endDate) {
      this.searchDate.startDate = startDate;
      this.searchDate.endDate = endDate;
    },

    async save() {
      if ((this.carOwnerNm && this.carNo && this.discountCd && this.note) != '') {
        let applyDay = '';
        for (const i of this.applyDay) {
          applyDay += i;
        }
        const apiParams = new FormData();
        apiParams.append('carOwnerNm', this.carOwnerNm);
        apiParams.append('carNo', this.carNo);
        apiParams.append('freeNote', this.freeNote);
        apiParams.append('applyDay', applyDay);
        apiParams.append('fctCode', this.fctCode);
        apiParams.append('startDtString', this.searchDate.startDate);
        apiParams.append('endDtString', this.searchDate.endDate);
        apiParams.append('orgNm', this.orgNm);
        if (this.sectnId == -1) {
          apiParams.append('parkingRegDiv', 'PRD-002');
        } else if (this.sectnId != undefined) {
          apiParams.append('sectnId', this.sectnId);
          apiParams.append('parkingRegDiv', 'PRD-001');
        } else {
          apiParams.append('parkingRegDiv', 'PRD-003');
        }
        const res = await axios('post', '/api/admin/freecar/insertAction.json', apiParams);
        if (res.data?.resultMap?.code == '00') {
          this.$router.push('freevehicle');
        } else {
          alert('다시 시도해주세요');
        }
      }
    },
    sectnIdChk() {
      if (this.sectnId < 0) {
        this.sectnIdChkReturn = true;
      }else {
        this.sectnIdChkReturn = false;
      }
    },
    async duplicateCheck() {
      if (!this.$v.carNo.carNoCheck || this.carNo == '') {
        alert('차량 형식에 맞게 입력해주세요.');
        return;
      }
      if(this.sectnId == '') {
        alert('주차장 선택 후 확인해주세요.');
        return;
      }
      const apiParams = new FormData();
      apiParams.append('carNo', this.carNo.replace(/ /gi, ''));
      apiParams.append('sectnId', this.sectnId);
      const res = await axios('post', '/api/admin/freecar/carNoCheck.json', apiParams);
      const data = res.data?.hashMap?.result?.result;
      if (data) {
        this.dupChk = true;
        alert('등록 가능한 차량입니다.');
      } else {
        alert('이미 등록중인 차량입니다.');
      }
    },
  },
};
</script>
